import { store } from '../../../../services/store/store';
import { uuid } from '../../../../utils/uuid';

export const generateUUIDForNewNode = () => {
  const nodes = store.getState().workflow.data.nodes;
  return uuid(nodes);
};
